import { z } from "zod";
import { JavaCurrencyValue } from "../../../utils/currency";

const JavaCurrencyValueSchema: z.ZodType<JavaCurrencyValue> = z.object({
  currency: z.string(),
  amount: z.string(),
  decimalPoints: z.string(),
  displayAmount: z.string(),
});

const SpendingEntrySchema = z.object({
  truncatedDate: z.string(),
  month: z.string(),
  quarter: z.string(),
  year: z.string(),
  amount: JavaCurrencyValueSchema,
});

export type SpendingEntry = z.infer<typeof SpendingEntrySchema>;

export const SpendingOverviewResultSchema = z.object({
  spendingOverview: z.object({
    FLIGHT: z.object({ transactions: z.array(SpendingEntrySchema) }).optional(),
    HOTEL: z.object({ transactions: z.array(SpendingEntrySchema) }).optional(),
  }),
});

export type SpendingOverviewResult = z.infer<
  typeof SpendingOverviewResultSchema
>;
